import axios from 'axios';
import type { DateTime } from 'luxon';

export default class LabelsService
{
    public static async getList(filter: FilterModel, pager: Pager)
    {
        return (await axios.get<Pagination<Resource<ListItemModel>>>(`admin/store/labels`, {
            params: { ...filter, ...pager.data() }
        })).data;
    }

    public static async fetch(id: number)
    {
        return (await axios.get<Resource<FormModel>>(`admin/store/labels/${id}`)).data;
    }

    public static async create(model: FormModel)
    {
        return (await axios.post(`admin/store/labels`, model)).data as ResponseModel;
    }

    public static async update(id: number, model: FormModel)
    {
        return (await axios.put(`admin/store/labels/${id}`, model)).data as ResponseModel;
    }

    public static async remove(id: number)
    {
        return (await axios.delete(`admin/store/labels/${id}`)).data as Statement;
    }

    public static async getAutocompleteList(search: string, limit: number = 10, excluded: number[] = [])
    {
        return (await axios.get<AutocompleteListModel[]>('admin/store/labels/autocomplete', {
            params: {
                search: search,
                limit: limit,
                excluded: excluded
            }
        })).data;
    }

    public static async fetchAutocompleteModel(id: number)
    {
        return (await axios.get<AutocompleteListModel[]>(`admin/store/labels/autocomplete/${id}`)).data;
    }

    public static async getListByIds(labelsIds: number[])
    {
        return (await axios.get<AutocompleteListModel[]>(`admin/store/labels/ids`, {
            params: {
                labelsIds: labelsIds
            }
        })).data;
    }
}

export interface ListItemModel
{
    id: number;
    createdBy: string;
    dateModifiedUtc?: DateTime;
    name: string;
    dateFormUtc?: DateTime;
    dateDueUtc?: DateTime;
}

export interface FormModel
{
    id: number;
    name: string;
    displayName: Record<string, string>;
    dateFromUtc?: DateTime;
    dateDueUtc?: DateTime;
    backgroundColor: string;
    borderColor: string;
    borderSize?: number;
    borderStyle: BorderStyleEnum;
    isTextBold: boolean;
    isTextItalic: boolean;
    isTextLineThrough: boolean;
    isTextOverline: boolean;
    isTextUnderline: boolean;
    paddingHorizontal?: number;
    paddingVertical?: number;
    priority: boolean;
    textColor: string;
    textDecorationColor: string;
    textDecorationStyle: TextDecorationStyleEnum;
    textSize?: number;
}

export interface FilterModel
{
    name: string;
    dateModifiedFromUtc?: DateTime;
    dateModifiedDueUtc?: DateTime;
}

export interface AutocompleteListModel
{
    id: number;
    name: string;
}

export interface ResponseModel
{
    id: number;
}
